import { render, staticRenderFns } from "./AnalysisRunsList.vue?vue&type=template&id=05da6464&scoped=true"
import script from "./AnalysisRunsList.vue?vue&type=script&lang=js"
export * from "./AnalysisRunsList.vue?vue&type=script&lang=js"
import style0 from "./AnalysisRunsList.vue?vue&type=style&index=0&id=05da6464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05da6464",
  null
  
)

export default component.exports